import { Text, Box } from "@simplybusiness/mobius";
import type { Disclaimers as DisclaimersType } from "../../../pages/ShowcasePage/types";
import "./Disclaimers.css";

type DisclaimersProps = {
  disclaimers: DisclaimersType;
};

export const Disclaimers = ({ disclaimers }: DisclaimersProps) => {
  const {
    coverageLimitDisclaimer,
    generalPriceDisclaimerText,
    productsPriceDisclaimersText,
  } = disclaimers;

  return (
    <Box className="mobius-disclaimers">
      {productsPriceDisclaimersText?.map((disclaimer, index) => (
        <Text
          key={index}
          variant="legal"
          className="mobius-disclaimers__legal-text"
        >
          {disclaimer}
        </Text>
      ))}

      {generalPriceDisclaimerText && (
        <Text variant="legal" className="mobius-disclaimers__legal-text">
          {generalPriceDisclaimerText}
        </Text>
      )}

      <Text variant="legal" className="mobius-disclaimers__legal-text">
        <sup>&dagger;</sup> {coverageLimitDisclaimer}
      </Text>
    </Box>
  );
};
